import {client} from '@core/GraphQLProvider';
import {InternationalResourceCountry, GetDistributorsBySite} from './query.graphql';

if ( process.env.MOCK_API == 1 ) {
    require( './mocks' );
}

const ResourcesService = {
    async getResourcesForCountry (languageCode ) {
        const resp = await client.query( {
            query: InternationalResourceCountry,
            variables: {languageCode}
        } );

        console.log( 'RESP', JSON.stringify(resp.data));
        return resp.data.internationalResourceCountry;
    },

    async GetDistributorsBySite ( languageCode ) {
        const resp = await client.query( {
            query: GetDistributorsBySite,
            variables: {languageCode}
        } );

        return resp.data.distributorsByCountry;
    }
};

export default ResourcesService;
